
import React, { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { DialogFooter } from '@/components/ui/dialog';
import CardFormContent from './form/CardFormContent';
import { useCategories } from '@/hooks/useCategories';

export interface CardItem {
  id: string;
  title: string;
  category: string;
  category_id?: string | null;
  agreePercentage: number;
  totalPollsters: number;
  description: string;
  status: 'draft' | 'published' | 'archived';
  country_code?: string | null;
  constituency_code?: string | null;
  insights?: string[];
  created_at?: string;
  updated_at?: string;
  slug?: string | null;
}

interface CardFormProps {
  currentCard: CardItem | null;
  setCurrentCard: (card: CardItem | null) => void;
  onCancel: () => void;
  onSave: () => void;
  isEditing: boolean;
}

const CardForm: React.FC<CardFormProps> = ({ 
  currentCard, 
  setCurrentCard, 
  onCancel, 
  onSave,
  isEditing
}) => {
  const { categories } = useCategories(true);
  
  // Ensure we have the category_id when the form loads
  useEffect(() => {
    if (currentCard && categories.length > 0 && !currentCard.category_id) {
      const matchingCategory = categories.find(cat => cat.name === currentCard.category);
      if (matchingCategory) {
        setCurrentCard({
          ...currentCard,
          category_id: matchingCategory.id
        });
      }
    }
  }, [currentCard, categories, setCurrentCard]);

  if (!currentCard) return null;

  return (
    <div className="grid gap-4 py-4">
      <CardFormContent 
        currentCard={currentCard}
        setCurrentCard={setCurrentCard}
        isEditing={isEditing}
      />

      <DialogFooter>
        <Button variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button onClick={onSave}>
          {isEditing ? 'Update' : 'Create'} Card
        </Button>
      </DialogFooter>
    </div>
  );
};

export default CardForm;
